import $ from 'jquery';

export default class SelectWidth {
  constructor($select) {
    this.$select = $select;
    this.$html = $('html');
    this.$body = $('body');

    this._adjustWidth = this._adjustWidth.bind(this);

    this.$select.on('change.select', this._adjustWidth);

    // Update width of <select> on load
    this._adjustWidth();
  }

  unload() {
    this.$select.off('.select');
  }

  /**
   * Adjust select to have width equal to its selected option
   *
   * @private
   */
  _adjustWidth() {
    const selectedText = this.$select.find(':selected').text();
    const $select = this.$select.parent().clone();

    const additionalStyles = {
      position: 'absolute',
      bottom: '-100%',
      left: '-100%',
      display: 'inline-block',
      visibility: 'hidden',
    };

    // Replace contents of copied <select> with selected text, and additional styles
    $select
      .css(additionalStyles)
      .find('select')
      .css('width', '') // Remove any width applied from previous with assignment
      .html(`<option>${selectedText}</option>`);
    this.$body.append($select);

    const width = $select.outerWidth(true);
    $select.remove();

    this.$select.css({width});
  }
}
